<script setup lang="ts">
import type { ViewType } from "~/components/Marketing/UProductActions.vue"

defineProps<{
  price: CrystallizeVariantPrice
  viewType: ViewType
}>()
</script>

<template>
  <span
    class="font-national2condensed text-product-mobile-price-md md:text-product-desktop-price-md"
    :class="{
      'text-[--theme-medium] [&>*]:text-[--theme-medium]':
        viewType === 'detail',
      'text-[--theme-dark] [&>*]:text-[--theme-dark]':
        viewType === 'list',
    }"
  >
    <template v-if="price.discount?.percentage">
      <i>Salg!</i>
      <mark
        class="ml-3 rounded-md bg-yellow-lighter px-2 py-1"
      >-{{ price.discount.percentage }}% Nå {{ price.discounted }},-
      </mark>
    </template>
    <i v-else-if="price.actual === 0">Gratis!</i>
    <template v-else>Pris {{ price.actual }},-</template>
  </span>
</template>
